import React from 'react';

import {useIntl} from 'react-intl';

import {Filter} from '../coaches-page/CoachesFilter';

import {FilterButton} from './FilterButton';
import {FilterContainer} from './FilterContainer';

type ToggleFilterProps = {
  filterId: string;
  filter: Filter;
  onFilterChange: (hasValue: boolean) => void;
  onOutsideClick: () => void;
  onMenuButtonClick: () => void;
  onSaveButtonClick: () => void;
};

const ToggleFilter: React.FC<React.PropsWithChildren<ToggleFilterProps>> = ({
  onFilterChange,
  filterId,
  filter,
}) => {
  const intl = useIntl();

  return (
    <FilterContainer id={filterId}>
      <FilterButton
        isActive={filter.active}
        menuOpen={filter.menuOpen}
        onClick={() => onFilterChange(!filter.value)}
        filterValue={filter.value}
        label={intl.formatMessage(filter.buttonLabelDescriptor)}
        showCaret={false}
      />
    </FilterContainer>
  );
};

export default ToggleFilter;
